(function(){
    'use strict'

    angular
    .module('app.empleados')
    .controller('Empleados', Empleados);

    Empleados.$inject = ['$q', '$animationsSrv', 'EmpleadosService', 'logger', '$location', 'TiposPlanillaService', 'PuestosService', 'DepartamentosService', 'UserInfoService', 'VacacionesDetalleService'];

    function Empleados($q, $animationsSrv, EmpleadosService, logger, $location, TiposPlanillaService, PuestosService, DepartamentosService, UserInfoService, VacacionesDetalleService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        var searchKey = "Empleados_Search_Criteria";

        vm.empleados = [];
        vm.puestos = [];
        vm.departamentos = [];
        vm.tiposPlanilla = [];
        vm.vacaciones = [];

        vm.busqueda = {
            puestoId: -1,
            departamentoId: -1,
            tipoPlanillaId: -1,
            nombre: '',
            identificacion: '',
            estado: -1
        };

        vm.title = 'Empleados';

        var promisePuesto = getPuesto();
        var promiseDepartamento = getDepartamento();
        var promiseTiposPlanilla = getTiposPlanilla();

        CargarPreviousSearch();

        vm.clearCriteria = function(){
            vm.busqueda = {
                puestoId: -1,
                departamentoId: -1,
                tipoPlanillaId: -1,
                nombre: '',
                identificacion: '',
                estado: -1
            };
        };

        vm.openModalVacaciones = function(empleado){
            var promise = VacacionesDetalleService.getByEmpleado(empleado.id);
            promise
            .then(function(result){
                vm.vacaciones = result;
                $('#myModalVacaciones').modal('toggle'); 
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las vacaciones del empleado.');
                        break;
                }
            });
             
        };

        vm.goToEdit = function(empleado){
            
            var path = '/editar-empleado/';

            if(empleado){
                $location.path(path + empleado.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.delete = function(empleado){
            var promise = EmpleadosService.remove(empleado);
            
            promise
            .then(function(response){
                vm.empleados = vm.empleados.filter(function(g) {
                    return g.id !== empleado.id;
                });
                logger.success('empleado eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el empleado');
                        break;
                }
                
            });   
        };

        function CargarPreviousSearch(){
            var previousSearch = UserInfoService.getDataFromSessionStorage(searchKey);
            if(previousSearch){
                vm.busqueda = previousSearch;
                $q.all([promiseDepartamento, promisePuesto, promiseTiposPlanilla]).then(function(){

                    vm.getAll();
                });               
            }
        };

        vm.getAll = function(){

            if(!vm.busqueda.companiaId){
                vm.busqueda.companiaId = UserInfoService.getCompaniaId();
            }

            var promise = EmpleadosService.getAll(vm.busqueda);

            promise
            .then(function(result){
                UserInfoService.saveDataOnSessionStorage(searchKey, vm.busqueda);
                vm.empleados = result.data;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los empleados.');
                        break;
                }
            });
        };

        vm.getExcel = function(){

            if(!vm.busqueda.companiaId){
                vm.busqueda.companiaId = UserInfoService.getCompaniaId();
            }

            var promise = EmpleadosService.getExcelFile(vm.busqueda);

            promise
            .then(function(result){
                logger.info('Excel descargado!');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los empleados.');
                        break;
                }
            });
        };

        function getPuesto(){
            var promise = PuestosService.getAll()
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getDepartamento(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAll(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

    }
})();